import * as React from 'react';
import { Typography } from '../Typography';
import { HideOffScreen } from '../HideOffScreen';
import { FormControl } from '../FormControl';
import { FormLabel } from '../FormLabel';
export var CheckboxGroup = React.forwardRef(function (props, ref) {
    var children = props.children, isRequired = props.isRequired, legendText = props.legendText, legendVariant = props.legendVariant, requiredLabel = props.requiredLabel, className = props.className;
    var Fieldset = FormControl;
    var Legend = FormLabel;
    if (!legendText) {
        throw new Error('legendText must be provided');
    }
    if (isRequired && !requiredLabel) {
        throw new Error('requiredLabel must be provided when setting isRequired="true"');
    }
    return (React.createElement(Fieldset, { className: className, component: "fieldset" },
        React.createElement(Legend, { component: "legend", required: isRequired },
            React.createElement(Typography, { variant: legendVariant, component: "span" },
                legendText,
                requiredLabel && React.createElement(HideOffScreen, null, requiredLabel))),
        React.createElement(FormControl, { ref: ref }, children)));
});
CheckboxGroup.defaultProps = {
    isRequired: false,
};
export default CheckboxGroup;
//# sourceMappingURL=CheckboxGroup.js.map